module.exports = __webpack_public_path__ + "static/media/a61.150556be.jpg";